import { graphql, useFragment } from "react-relay";

import { article as articleData, section as sectionData } from "shared/data";

import type { hooksSeriesArticleSectionTagArticle$key } from "scmp-app/queries/__generated__/hooksSeriesArticleSectionTagArticle.graphql";

export const useSeriesArticleSectionTag = (reference: hooksSeriesArticleSectionTagArticle$key) => {
  const seriesArticleSectionTag = useFragment(
    graphql`
      fragment hooksSeriesArticleSectionTagArticle on Article {
        sections {
          value {
            entityId
            name
          }
        }
        types {
          value {
            entityId
          }
        }
      }
    `,
    reference,
  );

  const seriesArticleSections =
    seriesArticleSectionTag?.sections
      ?.flatMap(sections => sections?.value ?? [])
      ?.filter(
        section =>
          section?.entityId !== sectionData.news.entityId &&
          section?.entityId !== sectionData.magazine.entityId,
      ) ?? [];

  const getSeriesItemSectionTag = () => {
    const seriesArticleSectionsIds = new Set(
      seriesArticleSections.map(seriesArticleSection => seriesArticleSection?.entityId ?? ""),
    );

    const articleTypeIds =
      seriesArticleSectionTag?.types?.flatMap(
        types => types?.value?.map(value => value?.entityId ?? "") ?? [],
      ) ?? [];

    if (articleTypeIds.includes(articleData.types.seriesDefaultLabel.entityId)) {
      return "SCMP Series";
    }

    if (seriesArticleSectionsIds.has(sectionData.thisWeekInAsia.entityId)) {
      return "This Week in Asia Series";
    }

    return `SCMP ${seriesArticleSections[0]?.name ?? ""} Series`;
  };

  return getSeriesItemSectionTag();
};
